import {Component, effect, inject, OnDestroy, OnInit} from '@angular/core';

import {MatToolbar} from '@angular/material/toolbar';
import {TenantSpecificAssetPipe} from '../../pipes/tenant-specific-asset.pipe';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatDialog} from '@angular/material/dialog';
import {SettingsComponent} from '../settings/settings.component';
import {UserMenuComponent} from '../user-menu/user-menu.component';
import {SessionService} from '../../services/session.service';
import {UserHal} from '../../models/HAL/user-hal.model';
import {Subject, takeUntil} from 'rxjs';
import {DialogService} from '../../services/dialog.service';
import {TenantInformationService} from '../../services/tenant-information.service';
import {CollaboratorHelperService} from '../../services/collaborator-helper.service';
import {Team} from '../../models/HAL/team-hal.model';

@Component({
  selector: 'app-header',
  imports: [
    MatToolbar,
    MatIconButton,
    MatIcon,
    UserMenuComponent
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  readonly dialog = inject(MatDialog);

  user: UserHal | undefined;
  team: Team | undefined;
  userMenuOpen = false;
  userInitials: string = ':O';

  private readonly destroy$ = new Subject<void>();
  headerLogoSrc: string = '';

  constructor(sessionService: SessionService,
              tenantInformationService: TenantInformationService,
              private readonly dialogService: DialogService,
              public readonly collaboratorHelperService: CollaboratorHelperService) {
    effect(() => {
      this.user = sessionService.session().user;
      this.team = sessionService.session().currentTeam;
      this.setUserInitials();
    });
    tenantInformationService.$tenant.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.headerLogoSrc = new TenantSpecificAssetPipe(tenantInformationService).transform('logo.png');
    });
  }

  ngOnInit() {
    this.setUserInitials();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openSettings() {
    this.dialogService.open(SettingsComponent, {
      width: '420px',
      height: 'auto',
      panelClass: 'settings-dialog'
    });
  }

  setUserInitials() {
    if (this.user) {
      this.userInitials = `${this.user.firstName.charAt(0)}${this.user.lastName.charAt(0)}`.toUpperCase();
    }
  }

  openUserMenu() {
    this.userMenuOpen = !this.userMenuOpen;
  }
}
